import clsx from "clsx";

import styles from "./inline-content.module.css";

const InlineContent = ({
  children,
  columnOnMobile = false,
}: {
  children: React.ReactNode;
  columnOnMobile?: boolean;
}) => {
  return (
    <div
      className={clsx(
        styles["product-card__inline"],
        columnOnMobile && styles["direction-column"],
      )}
    >
      {children}
    </div>
  );
};

export default InlineContent;
